module.exports = __webpack_public_path__ + "img/solution-data-logo3.5183401f.png";